import { createSelector } from "@reduxjs/toolkit";

import { LabList } from "custom-models/frontLoader";

import { ExternalLabsState } from "reducers/frontLoaderReducers";

export const selectExternalLabsForLab = createSelector(
  [
    (state: { externalLabs: ExternalLabsState }) => state.externalLabs,
    (_state, lab?: LabList) => lab,
  ],

  (externalLabs, lab) => {
    if (!lab) return [];
    return Object.values(externalLabs || {})
      .filter((l) =>
        lab.name === "PW Florida"
          ? l.name.includes("Bayshore") || l.name.includes("Seacoast")
          : lab.name === "PW SLC"
          ? l.name.includes("Intermountain") ||
            l.name.includes("Rocky Mountain")
          : false
      )
      .sort((a, b) =>
        a.name.localeCompare(b.name, "en", { sensitivity: "base" })
      );
  }
);
